// Consonants — base sound without inherent 'a' (matra / halant decides the vowel)
const CONSONANTS: Record<string, string> = {
  'क': 'k',   'ख': 'kh',  'ग': 'g',   'घ': 'gh',  'ङ': 'ng',
  'च': 'ch',  'छ': 'chh', 'ज': 'j',   'झ': 'jh',  'ञ': 'ny',
  'ट': 't',   'ठ': 'th',  'ड': 'd',   'ढ': 'dh',  'ण': 'n',
  'त': 't',   'थ': 'th',  'द': 'd',   'ध': 'dh',  'न': 'n',
  'प': 'p',   'फ': 'ph',  'ब': 'b',   'भ': 'bh',  'म': 'm',
  'य': 'y',   'र': 'r',   'ल': 'l',   'व': 'v',   'ळ': 'l',
  'श': 'sh',  'ष': 'sh',  'स': 's',   'ह': 'h',
};

const VOWELS: Record<string, string> = {
  'अ': 'a',   'आ': 'aa',  'इ': 'i',   'ई': 'ee',
  'उ': 'u',   'ऊ': 'oo',  'ऋ': 'ri',
  'ए': 'e',   'ऐ': 'ai',  'ओ': 'o',   'औ': 'au',
};

const MATRAS: Record<string, string> = {
  'ा': 'aa',  'ि': 'i',   'ी': 'ee',  'ु': 'u',   'ू': 'oo',
  'ृ': 'ri',  'े': 'e',   'ै': 'ai',  'ो': 'o',   'ौ': 'au',
  'ं': 'n',   'ः': 'h',   'ँ': 'n',   '़': '',
};

const HALANT = '्';

function _devanagari(text: string): string {
  const chars = [...text];
  let result = '';
  let i = 0;

  while (i < chars.length) {
    const ch = chars[i];

    if (CONSONANTS[ch] !== undefined) {
      const base = CONSONANTS[ch];
      const next = chars[i + 1];
      if (next === HALANT) {
        result += base;
        i += 2;
      } else if (next !== undefined && MATRAS[next] !== undefined) {
        result += base + MATRAS[next];
        i += 2;
      } else {
        result += base + 'a';
        i++;
      }
    } else if (VOWELS[ch] !== undefined) {
      result += VOWELS[ch];
      i++;
    } else if (ch === HALANT || MATRAS[ch] !== undefined) {
      i++;
    } else if (ch === '।' || ch === '॥') {
      result += ' ';
      i++;
    } else {
      result += ch;
      i++;
    }
  }

  return result;
}

/**
 * Suggests an English name from a book name:
 * - Latin-only text  → returned as-is (direct copy)
 * - Devanagari text  → transliterated to Roman; Latin parts pass through
 * - Other scripts    → returns '' so the user fills it manually
 */
export function autoEnglishName(text: string): string {
  if (!text || !text.trim()) return '';
  const t = text.trim();

  // Purely Basic Latin + Latin Extended (U+0000–U+024F): copy as-is
  const hasNonLatin = /[^ -ɏ\s]/.test(t);
  if (!hasNonLatin) return t;

  // Contains Devanagari (U+0900–U+097F)
  if (/[ऀ-ॿ]/.test(t)) {
    return _devanagari(t).replace(/\s+/g, ' ').trim();
  }

  // Other Unicode (Tamil, Telugu, Bengali…) — skip auto-fill
  return '';
}
